import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { ContactInfo } from '@/components/sections/ContactInfo'
import { ContactForm } from '@/components/sections/ContactForm'
import { MapSection } from '@/components/sections/MapSection'

export function Contacts() {
  const { t } = useTranslation()

  return (
    <main>
      <HeroPage
        title={t('contacts.hero.title')}
        subtitle={t('contacts.hero.subtitle')}
        backgroundImage="/images/general/hero_contatti.jpg"
        breadcrumb={[{ label: t('nav.contacts') }]}
      />
      <ContactForm />
      <ContactInfo />
      <MapSection />
    </main>
  )
}
